import { createClient } from '@/prismicio';

/**
 * Settings fetcher - fetches site-wide settings from Prismic.
 * Called once per request in layout.generateMetadata().
 * Relies on Prismic's built-in fetch caching (300s revalidation).
 */
export const getCachedSettings = async () => {
  const client = createClient();
  return await client.getSingle('settings');
};
